// =======================
// src/estilos/feedbacks.js
// =======================

import { ajustarTamanhoFonteAdmin } from "./global";

export const feedbackInlineBase = {
  width: "100%",
  alignItems: "flex-start",
  borderRadius: 1.5,
  border: "1px solid",
  boxShadow: "none",
  px: 1.75,
  py: 1.25,

  "& .MuiAlert-icon": {
    mt: 0.15,
    mr: 1.25,
    fontSize: 22,
  },

  "& .MuiAlert-message": {
    width: "100%",
    p: 0,
  },
};

export const feedbackInlinePorTipo = {
  error: {
    backgroundColor: "#fff4f4",
    borderColor: "#efb8b8",
    color: "#9f2525",

    "& .MuiAlert-icon": {
      color: "#d32f2f",
    },
  },

  warning: {
    backgroundColor: "#fff9ed",
    borderColor: "#f1d49a",
    color: "#865d0d",

    "& .MuiAlert-icon": {
      color: "#ed8c00",
    },
  },

  success: {
    backgroundColor: "#f1faf4",
    borderColor: "#a9d9b7",
    color: "#276738",

    "& .MuiAlert-icon": {
      color: "#2e7d32",
    },
  },

  info: {
    backgroundColor: "#eef6ff",
    borderColor: "#b8d7f5",
    color: "#235d91",

    "& .MuiAlert-icon": {
      color: "#087cf0",
    },
  },
};

export const tituloFeedbackInline = {
  fontSize: ajustarTamanhoFonteAdmin("0.95rem"),
  fontWeight: 700,
  lineHeight: 1.35,
  mb: 0.25,
};

export const mensagemFeedbackInline = {
  fontSize: ajustarTamanhoFonteAdmin("0.875rem"),
  fontWeight: 400,
  lineHeight: 1.45,
};
